<template id="map-template">
  <div class="homeview-videocenter-data">
    <div class="header">
      <span class="header-title">视频监控</span>
      <div class="arrow-pic"></div>
      <div class="icon-spread"></div>
    </div>
    <div class="table-chart">
      <HomeViewVideoMonitor></HomeViewVideoMonitor>
    </div>
  </div>
</template>

<script>
import HomeViewVideoMonitor from "./HomeViewVideoMonitor";

export default {
  name: "HomeViewVideoCenter",
  componentName: "HomeViewVideoCenter",
  components: {
    HomeViewVideoMonitor
  },
  props: {},
  data() {
    return {}
  },
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>